// src/modules/PreOperations/Form.jsx
import React, { useState, useEffect } from "react";
import { Form, Input, Radio, Button, Space, Divider, message } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const FormComp = ({ initialValues = {}, onSuccess, closeModal }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    form.setFieldsValue(initialValues || {});
  }, [initialValues, form]);

  const onFinish = async (vals) => {
    setLoading(true);
    const { id } = initialValues || {};

    const url = id
      ? `${API_URL}/pre-operaciones/${id}`
      : `${API_URL}/pre-operaciones`;
    const method = id ? "PUT" : "POST";

    const token = localStorage.getItem("accessToken");

    try {
      await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify(vals),
      });
      message.success("Pregunta guardada correctamente.");
      form.resetFields();
      onSuccess();
      closeModal();
    } catch (error) {
      console.error("Error saving pre operation:", error);
      message.error("Ocurrió un error al guardar.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={initialValues}
      onFinish={onFinish}
    >
      <Form.Item name="titulo" label="Pregunta" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item name="tipoRespuesta" label="Tipo" rules={[{ required: true }]}>
        <Radio.Group>
          <Radio value="texto">Texto</Radio>
          <Radio value="numerico">Numérico</Radio>
          <Radio value="checklist_simple">Checklist Simple</Radio>
          <Radio value="checklist_multiple">Checklist Múltiple</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item shouldUpdate={(p, c) => p.tipoRespuesta !== c.tipoRespuesta}>
        {() =>
          form.getFieldValue("tipoRespuesta") === "checklist_simple" && (
            <Form.List name="opciones">
              {(fields, { add, remove }) => (
                <>
                  <Divider>Opciones</Divider>
                  {fields.map(({ key, name, ...rest }) => (
                    <Space key={key} align="baseline">
                      <Form.Item
                        {...rest}
                        name={[name]}
                        rules={[{ required: true }]}
                      >
                        <Input placeholder="Opción" />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Button
                    type="dashed"
                    block
                    icon={<PlusOutlined />}
                    onClick={() => add()}
                  >
                    Agregar Opción
                  </Button>
                </>
              )}
            </Form.List>
          )
        }
      </Form.Item>

      <Form.Item shouldUpdate={(p, c) => p.tipoRespuesta !== c.tipoRespuesta}>
        {() =>
          form.getFieldValue("tipoRespuesta") === "checklist_multiple" && (
            <Form.List name="descripciones">
              {(groups, { add, remove }) => (
                <>
                  <Divider>Subpreguntas</Divider>
                  {groups.map(({ key, name, ...restGroup }) => (
                    <div
                      key={key}
                      style={{
                        padding: 8,
                        border: "1px solid #eee",
                        marginBottom: 8,
                      }}
                    >
                      <Space align="baseline">
                        <Form.Item
                          {...restGroup}
                          name={[name, "label"]}
                          rules={[{ required: true }]}
                        >
                          <Input placeholder="Etiqueta" />
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                      <Form.List name={[name, "options"]}>
                        {(options, { add: addOpt, remove: removeOpt }) => (
                          <>
                            {options.map(
                              ({ key: optKey, name: optName, ...optRest }) => (
                                <Space key={optKey} align="baseline">
                                  <Form.Item
                                    {...optRest}
                                    name={[optName]}
                                    rules={[{ required: true }]}
                                  >
                                    <Input placeholder="Opción múltiple" />
                                  </Form.Item>
                                  <MinusCircleOutlined
                                    onClick={() => removeOpt(optName)}
                                  />
                                </Space>
                              )
                            )}
                            <Button
                              type="dashed"
                              block
                              icon={<PlusOutlined />}
                              onClick={() => addOpt()}
                            >
                              Agregar Opción
                            </Button>
                          </>
                        )}
                      </Form.List>
                    </div>
                  ))}
                  <Button
                    type="dashed"
                    block
                    icon={<PlusOutlined />}
                    onClick={() => add()}
                  >
                    Agregar Subpregunta
                  </Button>
                </>
              )}
            </Form.List>
          )
        }
      </Form.Item>

      <Form.Item>
        <Button type="primary" block htmlType="submit" loading={loading}>
          Guardar
        </Button>
      </Form.Item>
    </Form>
  );
};

export default FormComp;
